export interface AppEnv {
  docsUrl: string;
  auth0: {
    domain: string;
    clientId: string;
    audience: string;
  };
}

export const appEnv: AppEnv = {
  docsUrl: import.meta.env.VITE_DOCS_URL,
  auth0: {
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  },
};
